interface TopBarProps {
  title: string
  description?: string
  className?: string
}

export default function TopBar({
  title,
  description = undefined,
  className,
}: TopBarProps) {
  return (
    <div id="topbar" className={`flex ${className ?? ''}`}>
      <div id="titlebar" className="w-11/12">
        <h1 className="text-primary-900 font-medium text-[30px] leading-[40px]	">
          {title}
        </h1>
        {description && <p className="text-primary-800 text-[18px]">{description}</p>}
      </div>
    </div>
  )
}
